module.exports = __webpack_public_path__ + "img/prep-with-text.b8e79c47.svg";